__turbopack_context__.v({
  "activeStep": "how-it-works-module__1sPK8W__activeStep",
  "splitLayoutGrid": "how-it-works-module__1sPK8W__splitLayoutGrid",
  "splitLayoutSection": "how-it-works-module__1sPK8W__splitLayoutSection",
  "stepContent": "how-it-works-module__1sPK8W__stepContent",
  "stepDescription": "how-it-works-module__1sPK8W__stepDescription",
  "stepIconContainer": "how-it-works-module__1sPK8W__stepIconContainer",
  "stepIconItself": "how-it-works-module__1sPK8W__stepIconItself",
  "stepItem": "how-it-works-module__1sPK8W__stepItem",
  "stepNumber": "how-it-works-module__1sPK8W__stepNumber",
  "stepText": "how-it-works-module__1sPK8W__stepText",
  "stepTitle": "how-it-works-module__1sPK8W__stepTitle",
  "stepsList": "how-it-works-module__1sPK8W__stepsList",
  "visualContent": "how-it-works-module__1sPK8W__visualContent",
  "visualPlaceholder": "how-it-works-module__1sPK8W__visualPlaceholder",
});
